import { BffResponse } from '../../../types/bff-types';
import { fetchBff } from './bff-fetch';

export const fetchOkapiMarketingCode = async (marketingCode: string): Promise<BffResponse | null> => {
	return fetchBff(`okapi/marketing-code?marketingCode=${marketingCode}`);
};
